import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchFilters} from "./filterApi";
import _ from 'lodash'
import moment from "moment";

export const defaultFiltersValue = {
    onsiteDrycleanerNumber: null,
    zones: [],
    orderNumber: null,
    status: 0,
    date: moment().format('YYYY-MM-DD')
};

const initialState = {
    filtersData: {
        onsiteDrycleaners: [],
        statuses: {},
        zones: []
    },
    filtersValue: Object.assign({}, defaultFiltersValue)
};

export const loadFiltersAsync = createAsyncThunk(
    'onsiteDrycleaning/filters/fetch',
    async (params = {}) => {
        const response = await fetchFilters(params);
        return response.data;
    }
);

export const filterSlice = createSlice({
    name: 'onsiteDrycleaningFilter',
    initialState,
    reducers: {
        modifyFilterValue(state, action) {
            if (action.payload.strategy) {
                const strategy = action.payload.strategy;
                const value = action.payload.value;
                let newState;
                if (strategy === 'without') {
                    newState = _.without(
                        state.filtersValue[action.payload.key],
                        ...(_.isArray(value) ? value : [value])
                    );
                } else if (strategy === 'union') {
                    newState = _.union(
                        state.filtersValue[action.payload.key],
                        value
                    );
                }
                state.filtersValue[action.payload.key] = newState;
            } else {
                state.filtersValue[action.payload.key] = action.payload.value;
            }
        },
        refreshFiltersValue(state) {
            state.filtersValue = Object.assign({}, defaultFiltersValue);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadFiltersAsync.fulfilled, (state, action) => {
                state.filtersData = action.payload;
            });
    },
});

export const {modifyFilterValue, refreshFiltersValue} = filterSlice.actions;
export const selectFiltersData = (state) => state.onsiteDrycleaningFilter.filtersData;
export const selectFiltersValueDate = (state) => state.onsiteDrycleaningFilter.filtersValue.date;
export const selectFiltersValueZones = (state) => state.onsiteDrycleaningFilter.filtersValue.zones;
export const selectFiltersValue = (state) => state.onsiteDrycleaningFilter.filtersValue;
export default filterSlice.reducer;
